import { defineComponent as _defineComponent } from 'vue'
import { ColorRequestConfig } from '@/modules/ColorModule/interfaces/ColorRequestConfig';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleRequest',
  props: {
    requestForm: null,
    validationErrors: null
  },
  emits: ["update-request-form"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update-request-form', key: keyof ColorRequestConfig, value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    requestForm: ColorRequestConfig;
    validationErrors: any;
};





const updateRequestForm = (key: keyof ColorRequestConfig, event: InputEvent) => {
    const value = (event.target as HTMLInputElement).value;

    emit('update-request-form', key, value);
};

return { __sfc: true,props, emit, updateRequestForm }
}

})